import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackClickedGenerateCDNButton = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedGenerateCDNButton = useCallback(() => {
    track(`Clicked Generate CDN Link button`);
  }, [track]);

  return { trackClickedGenerateCDNButton };
};
